// The SMS template rows, moved out of Settings.jsx with the Messages group.
export const SMS_TEMPLATE_FIELDS = [
  { key: 'pickup',          label: 'Pickup',          vars: '{name}, {bike}, {balance}, {shopName}, {shopPhone}, {shopHours}' },
  { key: 'estimate',        label: 'Estimate',        vars: '{name}, {bike}, {shopName}, {shopPhone}' },
  { key: 'pickup_reminder', label: 'Pickup Reminder', vars: '{name}, {bike}, {balance}, {shopName}, {shopPhone}, {shopHours}' },
  { key: 'special_order',   label: 'Special Order',   vars: '{name}, {bike}, {shopName}, {shopPhone}' },
];
